module.exports = __webpack_public_path__ + "static/img/login-v2-dark.58db2ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/login-v2-dark.svg
// module id = IHDD
// module chunks = 11